import { motion } from "framer-motion";

import MobileNav from "./MobileNav";
import useActiveSection from "../../hooks/useActiveSection";

const links = [
  { href: "#features", label: "01 Features" },
  { href: "#in-use", label: "02 In use" },
  { href: "#plans", label: "03 Plans" },
  { href: "#studio", label: "04 Studio" },
];

const sectionIds = [...links.map((l) => l.href.slice(1)), "contact"];

function NavLink({ href, label, isActive, className }) {
  return (
    <a href={href} className={`relative pb-1 transition-colors duration-200 ${className}`}>
      {label}
      {isActive && (
        <motion.span
          layoutId="nav-active-indicator"
          className="absolute inset-x-0 -bottom-px h-px bg-primary"
          transition={{ type: "spring", stiffness: 380, damping: 32 }}
        />
      )}
    </a>
  );
}

export default function Nav({ isOpen, setIsOpen }) {
  const active = useActiveSection(sectionIds);

  return (
    <>
      <header className="sticky top-0 z-30 flex flex-wrap items-baseline justify-between gap-6 border-b border-ink bg-paper/95 pb-[18px] pt-[22px] backdrop-blur-sm">
        <div className="unselectable font-reactor text-[22px] font-semibold [font-variation-settings:'wdth'_4]">
          FoundFoundry<span className="text-primary">®</span>
        </div>

        <nav className="hidden items-baseline gap-4 font-mono text-[11px] uppercase tracking-[0.16em] sm:flex md:gap-8">
          {links.map((l) => {
            const id = l.href.slice(1);
            const isActive = active === id;
            return (
              <NavLink
                key={l.href}
                href={l.href}
                label={l.label}
                isActive={isActive}
                className={isActive ? "text-primary" : "text-ink hover:text-primary"}
              />
            );
          })}
          <NavLink
            href="#contact"
            label="05 Contact →"
            isActive={active === "contact"}
            className="text-primary hover:text-primary-700"
          />
        </nav>

        <button
          type="button"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          onClick={() => setIsOpen(!isOpen)}
          className="font-mono text-[11px] uppercase tracking-[0.16em] transition-colors duration-200 hover:text-primary sm:hidden"
        >
          {isOpen ? "Close ✕" : "Menu ≡"}
        </button>
      </header>

      <MobileNav isOpen={isOpen} setIsOpen={setIsOpen} links={[...links, { href: "#contact", label: "05 Contact" }]} />
    </>
  );
}
